module.exports = __webpack_public_path__ + "img/about-ch2-urbanproblems-climatechange.bf033add.svg";